
export const DashboardAPI = {

  selectAllHubstaffProjects() {
    return $cfg.API.get('/admin/dashboard/hubstaff-projects');
  },

  selectAllHubstaffMembers() {
    return $cfg.API.get('/admin/dashboard/hubstaff-members');
  },
}
